import { NextRouterOptions } from '@nx-frontend/shared/utils';

export function goToSettings(router: NextRouterOptions, url: string) {
  if ('routerPushFn' in router) {
    router.routerPushFn('/space/settings' + url);
  }
}
